import { combineReducers } from 'redux'

import config from 'config'
import {
  LOADING_SALES,
  LOADING_SALES_SUCCEEDED,
  LOADING_SALES_FAILED,
  SALE_PAGE_CHANGE,
  SALE_ROWS_PER_PAGE_CHANGE
} from 'redux/actionTypes'

const byId = (state = {}, action) => {
  switch (action.type) {
    case LOADING_SALES_SUCCEEDED:
      return {
        ...state,
        ...action.payload.entities.sales
      }

    default:
      return state
  }
}

const isFetching = (state = false, action) => {
  switch (action.type) {
    case LOADING_SALES:
      return true
    case LOADING_SALES_SUCCEEDED:
    case LOADING_SALES_FAILED:
      return false
    default:
      return state
  }
}

const paginationInitialState = {
  currentPage: 1,
  rowsPerPage: Number(config.pagination.defaultRowsPerPage)
}

const rowCount = (state = 0, action) => {
  switch (action.type) {
    case LOADING_SALES_SUCCEEDED:
      return Number(action.count) || 0
    default:
      return state
  }
}

const pagination = (state = paginationInitialState, action) => {
  switch (action.type) {
    case SALE_PAGE_CHANGE:
      return {
        ...state,
        currentPage: action.page
      }
    case SALE_ROWS_PER_PAGE_CHANGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage
      }
    default:
      return state
  }
}

const salesReducer = combineReducers({
  byId,
  isFetching,
  pagination,
  rowCount
})

export default salesReducer

// sale selectors

export const getIsFetching = (state) => state.isFetching

export const getSale = (state, id) => state.byId[id] || {}

export const getSales = (state) => {
  let ids = Object.keys(state.byId)
  // sort the ids in desceding order
  ids.sort((a, b) => b.localeCompare(a))
  return ids.map(id => getSale(state, id))
}

// pagination selectors

export const getSalePage = (state) => state.pagination.currentPage

export const getSaleRowsPerPage = (state) => state.pagination.rowsPerPage

export const getSaleCount = (state) => state.rowCount



// WEBPACK FOOTER //
// ./src/redux/reducers/sales.js